import React, { useEffect, useState, Fragment } from "react";
import $ from "jquery";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../../Common/table";
import services from "../services";
import tokenService from "../../../../Common/tokenDecoder";
import MessageModal from "../../../../UI/Modal/MessageModal";
import {saveAs} from 'file-saver';
var JSZip = require("jszip");
var QRCode = require("qrcode.react");
var xlsx = require('json-as-xlsx');

const csvHeaders = [
  { label: "Registration Number", value: "registrationNumber" },
  { label: "Card Number", value: "cardNumber" },
  { label: "Name To Be Printed", value: "nameToBePrinted" },
  { label: "Date Of Birth", value: "dob" },
  { label: "NIC", value: "nic" },
  { label: "EPF", value: "epfNo" },
  { label: "Designation", value: "designation" },
  { label: "Gender", value: "gender" },
  { label: "Telephone", value: "telephone" },
];

export const EmployeeCardActivateListing = (props) => {
  const { cardActiveData, afterSuccessfulyChanged } = props;
  const [cardActivateFiltering, setCardActivateFiltering] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });

  const [checkAll, setCheckAll] = useState(false);

  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  useEffect(() => {
    trackPromise(setCardActivateData());

    setSaveData([]);
  }, [cardActiveData]);

  async function setCardActivateData() {
    await setCardActivateFiltering(cardActiveData);
  }

  function getBase64String(dataURL) {
    var idx = dataURL.indexOf('base64,') + 'base64,'.length;
    return dataURL.substring(idx);
 }

  function handleDownload() {
    var zip = new JSZip();
    var img = zip.folder("images");

    if (saveData.length != 0) {
      saveData.map(item => {

        const canvas = document.getElementById(item.registrationNumber);
        const pngUrl = canvas.toDataURL();
        let baseString = getBase64String(pngUrl);

        const imagename = item.registrationNumber + "." + "jpeg"
        img.file(imagename, baseString, { base64: true });
      })

    }
    zip.generateAsync({ type: "blob" })
      .then(function (content) { 
        // see FileSaver.js 
        saveAs(content, "Agrix-Employees.zip");
      });
  }

  function handleClick(data) {

    let dataRecords = [...saveData];
    let csvRecords = [...csvData];

    var isEnable = dataRecords.find((p) => p.cardID == data.cardID);
    if (isEnable === undefined) {
      let record = {
        registrationNumber: data.registrationNumber.toString(),
        cardNumber: data.cardNumber.toString(),
        nameToBePrinted: data.nameToBePrinted.toString(),
        dob: data.dateOfBirth.split('T')[0],
        nic: data.nic,
        epfNo: data.epfNo,
        designation: data.designationName,
        gender: data.genderID === "1" ? "M" : (data.genderID === "2" ? "F" : data.genderID),
        telephone: data.mobileNo !== null ? data.mobileNo : (data.homePhoneNo !== null ? data.homePhoneNo : (data.officePhoneNo !== null ? data.officePhoneNo : "-")),
      };

      var token = tokenService.getUserDetailsFromToken();

      let cardData = {
        cardID: data.cardID,
        createdBy: parseInt(token.id),
        cardNumber: data.cardNumber,
        registrationNumber: data.registrationNumber,
        nic: data.nic,
        name: data.nameToBePrinted,
        dateOfBirth: data.dateOfBirth.split('T')[0],
        epfNo: data.epfNo,
        phoneNo: data.mobileNo !== null ? data.mobileNo : (data.homePhoneNo !== null ? data.homePhoneNo : (data.officePhoneNo !== null ? data.officePhoneNo : "-")),
        gender: data.genderID === "1" ? "Male" : (data.genderID === "2" ? "Female" : data.genderID)
      };
      
      dataRecords.push(cardData);
      csvRecords.push(record);

    } else {
      var csvDataRemoveData = csvRecords.find(c => c.cardNumber == isEnable.cardNumber);

      var index = dataRecords.indexOf(isEnable);
      var csvIndex = csvRecords.indexOf(csvDataRemoveData);
      dataRecords.splice(index, 1);
      csvRecords.splice(csvIndex, 1);
    }

    setCsvData(csvRecords);
    setSaveData(dataRecords);
  }


  async function handleSave(e) {
    e.preventDefault();
    const response = await services.updateStatus(saveData);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }
  function handleClickAll(e){
    var token = tokenService.getUserDetailsFromToken();

    let cardDataCopy = [...saveData];
    let csvRecords = [...csvData];

    if(e.target.checked){
      cardActivateFiltering.forEach(x => {
        let cardData = {
          cardID: x.cardID,
          createdBy: parseInt(token.id),
          cardNumber: x.cardNumber,
          registrationNumber: x.registrationNumber,
          nic: x.nic,
          name: x.nameToBePrinted,
          dateOfBirth: x.dateOfBirth.split('T')[0],
          epfNo: x.epfNo,
          phoneNo: x.mobileNo !== null ? x.mobileNo : (x.homePhoneNo !== null ? x.homePhoneNo : (x.officePhoneNo !== null ? x.officePhoneNo : "-")),
          gender: x.genderID === "1" ? "Male" : (x.genderID === "2" ? "Female" : x.genderID)
        };

        let record = {
          registrationNumber: x.registrationNumber.toString(),
          cardNumber: x.cardNumber.toString(),
          nameToBePrinted: x.nameToBePrinted.toString(),
          dob: x.dateOfBirth.split('T')[0],
          nic: x.nic,
          epfNo: x.epfNo,
          designation: x.designationName,
          gender: x.genderID === "1" ? "M" : (x.genderID === "2" ? "F" : x.genderID),
          telephone: x.mobileNo !== null ? x.mobileNo : (x.homePhoneNo !== null ? x.homePhoneNo : (x.officePhoneNo !== null ? x.officePhoneNo : "-")),
        };

        var isEnable = cardDataCopy.find((p) => p.cardID == x.cardID);
        if(isEnable === undefined){
          cardDataCopy.push(cardData);
          csvRecords.push(record);
        }
      });
      setSaveData(cardDataCopy);
      setCsvData(csvRecords);
    }
    else {
      setSaveData([]);
      setCsvData([]);
    }
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }   

  function createFile(){
    var settings = {
      sheetName: 'Cards', // The name of the sheet
      fileName: 'EmployeeCardPrintDetails', // The name of the spreadsheet
      extraLength: 10, // A bigger number means that columns should be wider
      writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
    }
     
    var download = true // If true will download the xlsx file, otherwise will return a buffer
     
    xlsx(csvHeaders, csvData, settings, download) 
  }

  
  return (
    <Fragment>
      <LoadingSpinerComponent />
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title:(
              <label>
                <Checkbox
                  color="primary"
                  onClick={(e) => handleClickAll(e)}
                  onChange={selectAll}
                  checked={cardActivateFiltering.length != 0 && saveData.length == cardActivateFiltering.length}
                ></Checkbox>
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (data) => (
              <Checkbox
                color="primary"
                onClick={() => handleClick(data)}
                checked={!(saveData.find((x) => x.cardID == data.cardID) == undefined)}
              ></Checkbox>
            ),
          },
          { title: "Card Number", field: "cardNumber" },
          { title: "Registration Number", field: "registrationNumber" },
          { title: "First Name ", field: "firstName" },
          { title: "Name to be Printed", field: "nameToBePrinted" },
          
        ]}
        data={cardActivateFiltering}
      />

      <div className="card-footer">
        <input
          type="submit"
          className="btn btn-primary pull-right ml-2"
          value="Activate"
          onClick={(e) => trackPromise(handleSave(e))}
        />
        <input
          type="submit"
          className="btn btn-primary pull-right ml-2"
          value="Save As Images"
          onClick={handleDownload}
        />
        <input
          type="button"
          className="btn btn-primary pull-right ml-2"
          value="File Create"
          onClick={createFile}
        />
      </div>
      <div hidden={true}>
          {
            saveData.map((d) => (
             (
                   <QRCode id={d.registrationNumber} value={d.cardNumber} size={100} bgColor="#FFFFFF" fgColor="#000000" />
              )))
          }
        </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
  
};
